import React, { useEffect, useRef, useState } from 'react';
import './Header.css';
import logooficial from '../assets/images/norea.png';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSignOutAlt,
  faBell,
  faUserCircle,
  faChevronDown,
  faKey,
  faIdCard,
} from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

import { useNavigate } from 'react-router-dom';

function Header({ handleLogout }) {
  const [userInfo, setUserInfo] = useState({ nome: '', logo: '' });
  const [usuarioLocal, setUsuarioLocal] = useState(null);
  const [userMenuOpen, setUserMenuOpen] = useState(false);

  const userMenuRef = useRef(null);

  const [waStatus, setWaStatus] = useState({
    whatsapp_ativo: 0,
    connected: null,
    paymentStatus: null,
    loading: true,
  });

  const navigate = useNavigate();

  useEffect(() => {
    try {
      const raw = localStorage.getItem('usuario');
      const usuario = raw ? JSON.parse(raw) : null;
      setUsuarioLocal(usuario);
    } catch {
      setUsuarioLocal(null);
    }
  }, []);

  const isSubusuario =
    Number(usuarioLocal?.subusuario || 0) === 1 ||
    usuarioLocal?.subusuario === true ||
    usuarioLocal?.subusuario === '1';

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        userMenuRef.current &&
        !userMenuRef.current.contains(event.target)
      ) {
        setUserMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const response = await fetch(
          'https://welaunchyou.com.br/crm-wly/getUserInfo.php',
          {
            credentials: 'include',
          }
        );

        if (!response.ok) {
          console.error(
            'Erro ao buscar informações do usuário:',
            response.statusText
          );
          return;
        }

        const data = await response.json();

        const avatarPath = data.logo
          ? `https://welaunchyou.com.br/crm-wly/${data.logo.replace(/\\/g, '/')}`
          : '';

        setUserInfo({
          ...data,
          logo: avatarPath,
        });
      } catch (error) {
        console.error('Erro ao buscar informações do usuário:', error);
      }
    };

    fetchUserInfo();
  }, []);

  useEffect(() => {
    let alive = true;
    let timer = null;

    const fetchWaStatus = async () => {
      try {
        const res = await fetch('/crm-wly/api/whatsapp/status_instancia.php', {
          credentials: 'include',
          cache: 'no-store',
        });

        if (!res.ok) {
          if (alive) {
            setWaStatus((s) => ({
              ...s,
              loading: false,
            }));
          }

          return;
        }

        const data = await res.json();

        if (!alive) return;

        setWaStatus({
          whatsapp_ativo: Number(data?.whatsapp_ativo || 0),
          connected: typeof data?.connected === 'boolean' ? data.connected : null,
          paymentStatus: data?.paymentStatus ?? null,
          loading: false,
        });
      } catch (e) {
        if (alive) {
          setWaStatus((s) => ({
            ...s,
            loading: false,
          }));
        }
      }
    };

    fetchWaStatus();
    timer = setInterval(fetchWaStatus, 30000);

    return () => {
      alive = false;

      if (timer) {
        clearInterval(timer);
      }
    };
  }, []);

  const handleNotificationClick = () => {
    alert('Sem notificações');
  };

  const handleGo = (path) => {
    setUserMenuOpen(false);
    navigate(path);
  };

  const renderWaStatus = () => {
    if (waStatus.loading) return null;
    if (waStatus.whatsapp_ativo !== 1) return null;

    const paymentUpper = String(waStatus.paymentStatus || '').toUpperCase();

    const isCanceled =
      paymentUpper === 'CANCELED' ||
      paymentUpper === 'CANCELLED' ||
      paymentUpper === 'CANCELLATION_PROCESS';

    let statusClass = 'wa-status-off';
    let statusLabel = 'Desconectado';

    if (isCanceled) {
      statusClass = 'wa-status-canceled';
      statusLabel = 'Cancelado';
    } else if (waStatus.connected === true) {
      statusClass = 'wa-status-on';
      statusLabel = 'Conectado';
    } else if (waStatus.connected === false) {
      statusClass = 'wa-status-off';
      statusLabel = 'Desconectado';
    }

    return (
      <div className={`wa-status ${statusClass}`}>
        <FontAwesomeIcon
          icon={faWhatsapp}
          className="wa-icon"
          title={`WhatsApp ${statusLabel}`}
          onClick={() => navigate('/wzp/painel-mensagens')}
          style={{ cursor: 'pointer' }}
        />

        <span
          className="wa-indicator"
          title={`WhatsApp ${statusLabel}`}
        ></span>
      </div>
    );
  };

  const nomeExibicao =
    usuarioLocal?.nome ||
    userInfo?.nome ||
    'Usuário';

  const nomeConta =
    usuarioLocal?.nome_conta && usuarioLocal.nome_conta !== nomeExibicao
      ? usuarioLocal.nome_conta
      : '';

  return (
    <header className="header">
      <div className="header-content">
        <img
          src={logooficial}
          alt="Logo Nórea CRM"
          className="logooficial"
        />

        <h1 className="header-title">CRM</h1>
      </div>

      <div className="header-user-actions">
        <div className="header-avatar-wrap">
          {userInfo.logo && (
            <div className="header-avatar">
              <img
                src={userInfo.logo}
                alt={`Avatar de ${nomeExibicao}`}
                className="avatar"
              />
            </div>
          )}

          {renderWaStatus()}
        </div>

        <FontAwesomeIcon
          icon={faBell}
          className="notification-icon"
          title="Notificações"
          onClick={handleNotificationClick}
        />

        <div className="header-user-menu-wrap" ref={userMenuRef}>
          <button
            type="button"
            className={`header-user-menu-trigger ${
              userMenuOpen ? 'is-open' : ''
            }`}
            onClick={() => setUserMenuOpen((open) => !open)}
            title="Minha conta"
          >
            <FontAwesomeIcon icon={faUserCircle} className="header-user-icon" />
            <FontAwesomeIcon icon={faChevronDown} className="header-user-arrow" />
          </button>

          {userMenuOpen && (
            <div className="header-user-dropdown">
              <div className="header-user-dropdown-info">
                <strong>{nomeExibicao}</strong>

                {nomeConta && <span>{nomeConta}</span>}

                {isSubusuario && (
                  <small>Acesso de subusuário</small>
                )}
              </div>

              <button
                type="button"
                className="header-user-dropdown-item"
                onClick={() => handleGo('/alterar-senha')}
              >
                <FontAwesomeIcon icon={faKey} />
                <span>Alterar Senha</span>
              </button>

              {!isSubusuario && (
                <button
                  type="button"
                  className="header-user-dropdown-item"
                  onClick={() => handleGo('/meus-dados')}
                >
                  <FontAwesomeIcon icon={faIdCard} />
                  <span>Meus Dados</span>
                </button>
              )}

              <button
                type="button"
                className="header-user-dropdown-item header-user-dropdown-logout"
                onClick={() => {
                  setUserMenuOpen(false);
                  handleLogout?.();
                }}
              >
                <FontAwesomeIcon icon={faSignOutAlt} />
                <span>Sair</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;